import { Country } from '@/helpers/conf';
import { useServer } from '@/modules/server/context/ServerEnvContext';

export const useCurrentCountry = (country: Country) => {
  const { countryCode } = useServer();
  return countryCode === country;
};
